<template>
    <div class="widget">
        <div class="panel">
            <div class="panel-heading">
                <span class="badge" v-if="courseAlerts">{{alertCount}}</span>
                <h2>Course Alerts<i class="clippie fa fa-info-circle" v-tooltip="'Find your time sensitive course alerts below'"></i></h2>
                <div class="toggle-widget" @click="open=!open">
                    <i v-if="open===true" class="fa fa-minus"></i>
                    <i v-else class="fa fa-plus"></i>
                </div>
            </div>
            <div class="panel-body" v-show="open">
                <ul v-if="courseAlerts && courseAlerts.length > 0" class="class-alerts clearfix path-alert">
                    <li v-for="alert in courseAlerts">
                        <a :href="alert.link">
                            <img src="./../../assets/img/bullhorn.png">
                            <div class="alert-text">
                                <span class="alert-name" v-if="alert.meetingId">Weekly Update</span>
                                <span class="alert-name" v-else>{{alert.name}}</span>
                                <br>{{alert.dueDate | shortDate}}<br>
                                <countdown :date="alert.dueDate" ></countdown>
                            </div>
                        </a>
                    </li>
                </ul>   
              
                <p v-else>No alerts at this time</p>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import weeklyUpdates from '../../services/weekly-updates';

import Countdown from '../reusable/countdown/CountdownTimer.vue';
import moment from 'moment';
import toastr from 'toastr';

export default {
    data() {
        return {
            courseAlerts: null,
            checkins: null,
            open: true
        }
    },
    components: {
        Countdown
    },
    mounted() {
        this.getAlerts();

        this.$bus.$on('reloadAlerts', () => {
            this.getAlerts();
        });
      
    },
    methods: {
        async getAlerts() {
            const oneMonthAgo = moment().subtract(1, 'month').toDate();
            this.courseAlerts = null;
            let updateAlerts = await weeklyUpdates.getAlerts();
            if (updateAlerts.data.success === true) {
                const now = new Date();
                this.courseAlerts = updateAlerts.data.alerts
                    .filter((a) => {
                        return !a['weekly_update.id'];
                    })                    
                    .filter((a)=>{
                        return a['weekly_update.attended'] === true || a['weekly_update.attended'] === false || new Date(a.startDate) > oneMonthAgo;
                    })
                    .map((a) => {
                        a.link = '/#/weekly-updates';
                        return a;
                    })
                    .sort((a, b) => {
                        return new Date(a.dueDate) - new Date(b.dueDate);
                    });

            } else {
                toastr.error('Error getting weekly updates');
                updateAlerts = [];
            }


        },       
       
    },

    computed: {
        alertCount() {
            let count = this.courseAlerts.length;
            if (this.checkins) count += this.checkins.length;
            return count;
        },
        week() {
            return this.$store.getters.realCurrentWeek;
        }
    }
}

</script>
<style lang="scss" scoped>
.overdue {
    color: red;
}

.panel-body p {
    text-align: center;
    padding-top: 2rem;
}

.class-alerts {
    padding-bottom: 0rem;
}

.path-alert {
    padding-top: 0 !important;
    padding-bottom: 0rem;

}

.panel-body>ul:last-child {
    padding-bottom: 2rem;
}

a {
    color: inherit;
}

ul {
    clear: both;
    padding-bottom: 2rem;
    padding-top: 1.5rem;
}

li {
    padding: 1rem 1rem 1rem 2rem;
    clear: both;
}

h5 {
    margin-bottom: 0;
}

img,
.alert-text {
    display: block;
    float: left;
}

.alert-text {
    padding-left: 1rem;
    max-width: 80%;
}

.alert-name {
    color: white;
}

</style>



// WEBPACK FOOTER //
// SupervisorAlerts.vue?ffb0405c